export default "__VITE_ASSET__DHZZV8vF__"